import { Experiment } from "@func-core/core/domain/view-models";

export const EXPERIMENT_VARIANTS = {
  ENABLED: "enabled",
  DISABLED: "disabled",
} as const;

export const EXPERIMENT_IDS = {
  CUSTOM_CHECKOUT_SESSION: "custom-checkout-session",
} as const;

export const EXPERIMENTS: Experiment[] = [
  {
    id: EXPERIMENT_IDS.CUSTOM_CHECKOUT_SESSION,
    name: "Custom Checkout Session",
    variants: [
      { id: EXPERIMENT_VARIANTS.ENABLED, name: "Custom Checkout Session Enabled", weight: 1 },
      { id: EXPERIMENT_VARIANTS.DISABLED, name: "Custom Checkout Session Disabled", weight: 0 },
    ],
    countries: [],
  },
];
